// extracted by extract-css-chunks-webpack-plugin
module.exports = {"FlySelect":"FlySelect_1YgLJ_v16-5-1","FlySelect__Readonly":"FlySelect__Readonly_3OWNl_v16-5-1"};